import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import MemoryPalaceMap from './MemoryPalaceMap';
import MemoryPalaceNarrative from './MemoryPalaceNarrative';

const MemoryPalace = () => {
  const { id } = useParams();
  const [currentCheckpoint, setCurrentCheckpoint] = useState(0);
  
  // Get the memory from localStorage
  const memories = JSON.parse(localStorage.getItem('memories') || '[]');
  const memory = memories.find(m => m.id === Number(id));

  // Example checkpoints (in real app, these would be generated by AI)
  const checkpoints = [
    { position: { x: 50, y: 50 }, description: "Entry Point" },
    { position: { x: 150, y: 100 }, description: memory?.location || "Location" },
    { position: { x: 250, y: 50 }, description: "Key Memory" },
    { position: { x: 350, y: 100 }, description: "Final Scene" }
  ];

  // Example narrative segments (in real app, these would be generated by AI)
  const narrativeSegments = [
    `You begin your journey into the memory of "${memory?.title}"...`,
    `You find yourself in ${memory?.location}...`,
    `You can vividly recall: ${memory?.details?.substring(0, 100)}...`,
    "The memory gently fades as you complete your journey..."
  ];

  const handleSegmentComplete = () => {
    if (currentCheckpoint < narrativeSegments.length - 1) {
      setCurrentCheckpoint(prev => prev + 1);
    }
  };

  if (!memory) {
    return <div>Memory not found</div>;
  }

  return (
    <div className="memory-palace-page">
      <h2 className="memory-palace-title">{memory.title}</h2>
      <div className="memory-palace-container">
        <MemoryPalaceMap 
          narrativeCheckpoints={checkpoints}
          currentCheckpoint={currentCheckpoint}
        />
        <MemoryPalaceNarrative
          narrative={narrativeSegments}
          currentSegment={currentCheckpoint}
          onSegmentComplete={handleSegmentComplete}
        />
      </div>
    </div>
  );
};

export default MemoryPalace; 